import { z } from 'zod';
// A top category being present means the partner covers all of its child categories; child categories may also be selected individually.
export const workCategoriesStepSchema = z.object({
    topCategoryUuids: z.array(z.uuid()),
    childCategoryUuids: z.array(z.uuid()),
});
export const workCategoryOptionSchema = z.lazy(() => z.object({
    uuid: z.uuid(),
    key: z.string(),
    children: z.array(workCategoryOptionSchema),
}));
export const workCategoryOptionsResponseSchema = z.object({
    categories: z.array(workCategoryOptionSchema),
});
